import { HowToUseIt } from './HowToUseIt';

export default HowToUseIt;
